import { isDateInPast } from 'Rentlio/helper/isDateInPast'

// Return true if payment date is in the past or today
// Note: dateToday is just for mocking in tests
const hasPaymentDatePassed = (arrival, daysBeforeArrivalToChargePayment, dateToday) => {
  return isDateInPast(
    arrival.clone().subtract(daysBeforeArrivalToChargePayment ? +daysBeforeArrivalToChargePayment : 0, 'days'),
    true,
    dateToday
  )
}

export default hasPaymentDatePassed
